import { WidgetHelper } from '@/helpers/Widget'

import FabWidget from '@/modules/FabWidget/components/FabWidget'

WidgetHelper.reTry('#fab-widget', FabWidget)
